import React from 'react';
import styled from 'styled-components';
import { Link, useStaticQuery, graphql } from 'gatsby';

const Banner = styled.div`
  background-color: ${props => {
    if(props.banner === 'Promo'){
      return `var(--gold)`
    } else if(props.banner === 'Sale') {
      return `var(--black)`
    } else if(props.banner === 'Info') {
      return `var(--info)`
    } else if(props.banner === 'Alert') {
      return `var(--yellow)`
    }
  }};
	height: 35px;
	text-align: center;
	font-size: 0.75em;
	letter-spacing: 0.18em;
	text-transform: Uppercase;
	color: var(--light);
	display: grid;
	align-items: center;
`;

export default function Alert() {
	const data = useStaticQuery(graphql`
		query Alert {
			sanitySiteSettings {
				alert {
					callToAction {
						url
						text
					}
					id
					title
					text
					style
					_createdAt(locale: "")
				}
			}
		}
	`);

	const { title,style } = data.sanitySiteSettings.alert;
	const { url, text } = data.sanitySiteSettings.alert.callToAction;

	return (
		<div className="w3-row">
			{title && (
				<Banner banner={style}>
					<span>
						{title}  {url && <Link to={`/${url}/`}>{text}</Link>}
					</span>
				</Banner>
			)}
		</div>
	);
}
